// @dynamic-i18n-keys
// Dynamic t() at lines 15, 22, 26 (errorName from ErrorNames):
//   searchPage.emptyState.title.none
//   searchPage.emptyState.title.request
//   searchPage.emptyState.title.highOffset
//   searchPage.emptyState.title.noResults
//   searchPage.emptyState.title.pastEndOfResults
//   searchPage.emptyState.title.allMature
//   searchPage.emptyState.title.allStored
//   searchPage.emptyState.title.allDeleted
//   searchPage.emptyState.title.allAntisocial
//   searchPage.emptyState.title.highLoad
//   searchPage.emptyState.title.allBlocked
//   searchPage.emptyState.title.noDeviantsYouWatch
//   searchPage.emptyState.title.tagBlocked
//   searchPage.emptyState.error.none
//   searchPage.emptyState.error.request
//   searchPage.emptyState.error.highOffset
//   searchPage.emptyState.error.noResults
//   searchPage.emptyState.error.pastEndOfResults
//   searchPage.emptyState.error.allMature
//   searchPage.emptyState.error.allStored
//   searchPage.emptyState.error.allDeleted
//   searchPage.emptyState.error.allAntisocial
//   searchPage.emptyState.error.highLoad
//   searchPage.emptyState.error.allBlocked
//   searchPage.emptyState.error.noDeviantsYouWatch
//   searchPage.emptyState.error.tagBlocked
//   searchPage.emptyState.suggestion.none
//   searchPage.emptyState.suggestion.request
//   searchPage.emptyState.suggestion.highOffset
//   searchPage.emptyState.suggestion.noResults
//   searchPage.emptyState.suggestion.pastEndOfResults
//   searchPage.emptyState.suggestion.allMature
//   searchPage.emptyState.suggestion.allStored
//   searchPage.emptyState.suggestion.allDeleted
//   searchPage.emptyState.suggestion.allAntisocial
//   searchPage.emptyState.suggestion.highLoad
//   searchPage.emptyState.suggestion.allBlocked
//   searchPage.emptyState.suggestion.noDeviantsYouWatch
//   searchPage.emptyState.suggestion.tagBlocked
//   facetPage.emptyState.title
//   facetPage.emptyState.suggestion
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorNames } from '../../../constants';
import s from './EmptyResult.scss';

export interface Props {
  errorName: ErrorNames;
}

const DefaultEmptyResult: FC<Props> = ({ errorName }) => {
  const { t } = useTranslation();
  return (
    <div className={s['empty-state-root']}>
      <div className={s['empty-state-label']}>
        {t([
          `searchPage.emptyState.title.${errorName}`,
          'facetPage.emptyState.title',
        ])}
      </div>
      {errorName && (
        <div className={s['empty-state-error']}>
          {t(`searchPage.emptyState.error.${errorName}`)}
        </div>
      )}
      <div className={s['empty-state-suggestion']}>
        {t([
          `searchPage.emptyState.suggestion.${errorName}`,
          'facetPage.emptyState.suggestion',
        ])}
      </div>
    </div>
  );
};
DefaultEmptyResult.displayName = 'DefaultEmptyResult';

export default DefaultEmptyResult;
